<h4>NuReferral 340B Referral Program Performance Metrics</h4>
@if (!loading && client) {
  @if (client.programMetricsLastUpdatedAt) {
    <div
      class="mb-4 program-metrics-last-updated-at"
      >
      Last Updated: {{ client.programMetricsLastUpdatedAt | date: 'MM/dd/yyyy' }}
    </div>
  }
  <app-client-info-card [client]="client" />
  @if (client.clientMetricsEnabled) {
    <app-client-program-metrics [client]="client" />
  }
} @else if (loading) {
  <mat-spinner diameter="30" style="margin: auto;" />
} @else {
  <p class="text-danger mt-3">Unable to load client data.</p>
}
